export default __webpack_public_path__ + "static/media/id.e0561c48.svg";